module.exports = __webpack_public_path__ + "img/1-5.57fc293e.svg";